import { TableCell } from '@mui/material';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { TransactionCellContent } from '@/components/molecules/TransactionCellContent';
import { Transaction } from '@/types/transaction';
import { TransactionRow } from '@/types/transactionRow';

interface Props {
  readonly transaction: Transaction;
  readonly field: keyof TransactionRow;
  readonly sx?: SystemStyleObject;
}

export const TransactionTableCell: React.FC<Props> = ({
  transaction,
  field,
  sx,
}: Props): React.ReactElement => {
  return (
    <TableCell sx={sx}>
      <TransactionCellContent transaction={transaction} field={field} />
    </TableCell>
  );
};
